import { CUSTOM_FIELDS_REDUCER_KEY } from 'store/customFields/actions'
import { CustomFieldsState } from 'store/customFields/interfaces'

export const customFieldsSelector = (state: { [CUSTOM_FIELDS_REDUCER_KEY]: CustomFieldsState }) =>
  state[CUSTOM_FIELDS_REDUCER_KEY]
